import * as Dtos from "../dtos/Tmd.dtos";
import {  IFormFilter } from "../reducers/index";

export const
    LoadProjectItemTemplateCategory: IProjectItemTemplateCategoryLoadActionCreator = () => {
        return {
            type: ACTION_PROJECTITEMTEMPLATECATEGORY_LOAD
        }
    },
    LoadProjectItemTemplateCategoryById: IProjectItemTemplateCategoryLoadByIdActionCreator = (id) => {
        return {
            type: ACTION_PROJECTITEMTEMPLATECATEGORY_LOAD_BY_ID,
            id
        }
    },
    LoadSuccess: IProjectItemTemplateCategoryLoadSuccessActionCreator = (formData, formState, formProperties, lookups, responseStatus) => {
        return {
            type: ACTION_PROJECTITEMTEMPLATECATEGORY_LOAD_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups,
            responseStatus
        }
    },
    LoadFailure: IProjectItemTemplateCategoryLoadFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_PROJECTITEMTEMPLATECATEGORY_LOAD_FAILURE,
            responseStatus
        }
    },

    SaveProjectItemTemplateCategory: IProjectItemTemplateCategorySaveActionCreator = (formData) => {
        return {
            type: ACTION_PROJECTITEMTEMPLATECATEGORY_SAVE,
            formData
        }
    },
    SaveSuccess: IProjectItemTemplateCategorySaveSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_PROJECTITEMTEMPLATECATEGORY_SAVE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    SaveFailure: IProjectItemTemplateCategorySaveFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_PROJECTITEMTEMPLATECATEGORY_SAVE_FAILURE,
            responseStatus
        }
    },

    CreateProjectItemTemplateCategory: IProjectItemTemplateCategoryCreateActionCreator = () => {

        return {
            type: ACTION_PROJECTITEMTEMPLATECATEGORY_CREATE
        }
    },
    CreateSuccess: IProjectItemTemplateCategoryCreateSuccessActionCreator = (formData, formState, formProperties, lookups) => {
        return {
            type: ACTION_PROJECTITEMTEMPLATECATEGORY_CREATE_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups
        }
    },
    CreateFailure: IProjectItemTemplateCategoryCreateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_PROJECTITEMTEMPLATECATEGORY_CREATE_FAILURE,
            responseStatus
        }
    },

    ValidateProjectItemTemplateCategory: IProjectItemTemplateCategoryValidateActionCreator = (formData) => {
        return {
            type: ACTION_PROJECTITEMTEMPLATECATEGORY_VALIDATE,
            formData
        }
    },
    ValidateSuccess: IProjectItemTemplateCategoryValidateSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_PROJECTITEMTEMPLATECATEGORY_VALIDATE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    ValidateFailure: IProjectItemTemplateCategoryValidateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_PROJECTITEMTEMPLATECATEGORY_VALIDATE_FAILURE,
            responseStatus
        }
    },

    Clear: IProjectItemTemplateCategoryClearActionCreator = (propertiesToClear?) => {
        return {
            type: ACTION_PROJECTITEMTEMPLATECATEGORY_CLEAR,
            propertiesToClear
        }
    },
    Filter: IProjectItemTemplateCategoryFilterActionCreator = (formFilter) => {
        return {
            type: ACTION_PROJECTITEMTEMPLATECATEGORY_FILTER,
            formFilter
        }
    };



export const
    ACTION_PROJECTITEMTEMPLATECATEGORY_LOAD = "ACTION_PROJECTITEMTEMPLATECATEGORY_LOAD",
    ACTION_PROJECTITEMTEMPLATECATEGORY_LOAD_BY_ID = "ACTION_PROJECTITEMTEMPLATECATEGORY_LOAD_BY_ID",
    ACTION_PROJECTITEMTEMPLATECATEGORY_LOAD_SUCCESS = "ACTION_PROJECTITEMTEMPLATECATEGORY_LOAD_SUCCESS",
    ACTION_PROJECTITEMTEMPLATECATEGORY_LOAD_FAILURE = "ACTION_PROJECTITEMTEMPLATECATEGORY_LOAD_FAILURE",

    ACTION_PROJECTITEMTEMPLATECATEGORY_SAVE = "ACTION_PROJECTITEMTEMPLATECATEGORY_SAVE",
    ACTION_PROJECTITEMTEMPLATECATEGORY_SAVE_SUCCESS = "ACTION_PROJECTITEMTEMPLATECATEGORY_SAVE_SUCCESS",
    ACTION_PROJECTITEMTEMPLATECATEGORY_SAVE_FAILURE = "ACTION_PROJECTITEMTEMPLATECATEGORY_SAVE_FAILURE",

    ACTION_PROJECTITEMTEMPLATECATEGORY_CREATE = "ACTION_PROJECTITEMTEMPLATECATEGORY_CREATE",
    ACTION_PROJECTITEMTEMPLATECATEGORY_CREATE_SUCCESS = "ACTION_PROJECTITEMTEMPLATECATEGORY_CREATE_SUCCESS",
    ACTION_PROJECTITEMTEMPLATECATEGORY_CREATE_FAILURE = "ACTION_PROJECTITEMTEMPLATECATEGORY_CREATE_FAILURE",

    ACTION_PROJECTITEMTEMPLATECATEGORY_VALIDATE = "ACTION_PROJECTITEMTEMPLATECATEGORY_VALIDATE",
    ACTION_PROJECTITEMTEMPLATECATEGORY_VALIDATE_SUCCESS = "ACTION_PROJECTITEMTEMPLATECATEGORY_VALIDATE_SUCCESS",
    ACTION_PROJECTITEMTEMPLATECATEGORY_VALIDATE_FAILURE = "ACTION_PROJECTITEMTEMPLATECATEGORY_VALIDATE_FAILURE",

    ACTION_PROJECTITEMTEMPLATECATEGORY_CLEAR = "ACTION_PROJECTITEMTEMPLATECATEGORY_CLEAR",

    ACTION_PROJECTITEMTEMPLATECATEGORY_FILTER = "ACTION_PROJECTITEMTEMPLATECATEGORY_FILTER";

export interface IProjectItemTemplateCategoryLoadAction {
    type: "ACTION_PROJECTITEMTEMPLATECATEGORY_LOAD";
}

export interface IProjectItemTemplateCategoryLoadActionCreator {
    (): IProjectItemTemplateCategoryLoadAction;
}

export interface IProjectItemTemplateCategoryLoadSuccessAction {
    type: "ACTION_PROJECTITEMTEMPLATECATEGORY_LOAD_SUCCESS";
    formData: Dtos.ProjectItemTemplateCategory | Dtos.ProjectItemTemplateCategory[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
    responseStatus: Dtos.ResponseStatus;
}

export interface IProjectItemTemplateCategoryLoadSuccessActionCreator {
    (
        formData: Dtos.ProjectItemTemplateCategory | Dtos.ProjectItemTemplateCategory[],
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): IProjectItemTemplateCategoryLoadSuccessAction;
}

export interface IProjectItemTemplateCategoryLoadFailureAction {
    type: "ACTION_PROJECTITEMTEMPLATECATEGORY_LOAD_FAILURE";
    responseStatus: Dtos.ResponseStatus;
}

export interface IProjectItemTemplateCategoryLoadFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IProjectItemTemplateCategoryLoadFailureAction;
}

export interface IProjectItemTemplateCategoryLoadByIdAction {
    type: "ACTION_PROJECTITEMTEMPLATECATEGORY_LOAD_BY_ID";
    id: number;
}

export interface IProjectItemTemplateCategoryLoadByIdActionCreator {
    (id: number): IProjectItemTemplateCategoryLoadByIdAction;
}


export interface IProjectItemTemplateCategorySaveAction {
    type: "ACTION_PROJECTITEMTEMPLATECATEGORY_SAVE";
    formData: Dtos.ProjectItemTemplateCategory;

}

export interface IProjectItemTemplateCategorySaveActionCreator {
    (
        formData: Dtos.ProjectItemTemplateCategory
    ): IProjectItemTemplateCategorySaveAction;
}

export interface IProjectItemTemplateCategorySaveSuccessAction {
    type: "ACTION_PROJECTITEMTEMPLATECATEGORY_SAVE_SUCCESS";
    formData: Dtos.ProjectItemTemplateCategory;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface IProjectItemTemplateCategorySaveSuccessActionCreator {
    (
        formData: Dtos.ProjectItemTemplateCategory,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): IProjectItemTemplateCategorySaveSuccessAction;
}

export interface IProjectItemTemplateCategorySaveFailureAction {
    type: "ACTION_PROJECTITEMTEMPLATECATEGORY_SAVE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IProjectItemTemplateCategorySaveFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IProjectItemTemplateCategorySaveFailureAction;
}

export interface IProjectItemTemplateCategoryCreateAction {
    type: "ACTION_PROJECTITEMTEMPLATECATEGORY_CREATE"
}

export interface IProjectItemTemplateCategoryCreateActionCreator {
    (): IProjectItemTemplateCategoryCreateAction
}

export interface IProjectItemTemplateCategoryCreateSuccessAction {
    type: "ACTION_PROJECTITEMTEMPLATECATEGORY_CREATE_SUCCESS";
    formData: Dtos.ProjectItemTemplateCategory;
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
}

export interface IProjectItemTemplateCategoryCreateSuccessActionCreator {
    (
        formData: Dtos.ProjectItemTemplateCategory,
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[]
    ): IProjectItemTemplateCategoryCreateSuccessAction;
}

export interface IProjectItemTemplateCategoryCreateFailureAction {
    type: "ACTION_PROJECTITEMTEMPLATECATEGORY_CREATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IProjectItemTemplateCategoryCreateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IProjectItemTemplateCategoryCreateFailureAction;
}

export interface IProjectItemTemplateCategoryValidateAction {
    type: "ACTION_PROJECTITEMTEMPLATECATEGORY_VALIDATE";
    formData: Dtos.ProjectItemTemplateCategory;

}

export interface IProjectItemTemplateCategoryValidateActionCreator {
    (
        formData: Dtos.ProjectItemTemplateCategory
    ): IProjectItemTemplateCategoryValidateAction;
}

export interface IProjectItemTemplateCategoryValidateSuccessAction {
    type: "ACTION_PROJECTITEMTEMPLATECATEGORY_VALIDATE_SUCCESS";
    formData: Dtos.ProjectItemTemplateCategory;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface IProjectItemTemplateCategoryValidateSuccessActionCreator {
    (
        formData: Dtos.ProjectItemTemplateCategory,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): IProjectItemTemplateCategoryValidateSuccessAction;
}

export interface IProjectItemTemplateCategoryValidateFailureAction {
    type: "ACTION_PROJECTITEMTEMPLATECATEGORY_VALIDATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IProjectItemTemplateCategoryValidateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IProjectItemTemplateCategoryValidateFailureAction;
}

export interface IProjectItemTemplateCategoryClearAction {
    type: "ACTION_PROJECTITEMTEMPLATECATEGORY_CLEAR";
    propertiesToClear?: string[];
}

export interface IProjectItemTemplateCategoryClearActionCreator {
    (propertiesToClear?: string[]): IProjectItemTemplateCategoryClearAction;
}

export interface IProjectItemTemplateCategoryFilterActionCreator {
    (formFilter: IFormFilter): IProjectItemTemplateCategoryFilterAction;
}

export interface IProjectItemTemplateCategoryFilterAction {
    type: "ACTION_PROJECTITEMTEMPLATECATEGORY_FILTER";
    formFilter: IFormFilter;
}

export type ProjectItemTemplateCategoryAction =
    IProjectItemTemplateCategoryLoadAction |
    IProjectItemTemplateCategoryLoadByIdAction |
    IProjectItemTemplateCategoryLoadFailureAction |
    IProjectItemTemplateCategoryLoadSuccessAction |
    IProjectItemTemplateCategorySaveAction |
    IProjectItemTemplateCategorySaveSuccessAction |
    IProjectItemTemplateCategorySaveFailureAction |
    IProjectItemTemplateCategoryCreateAction |
    IProjectItemTemplateCategoryCreateSuccessAction |
    IProjectItemTemplateCategoryCreateFailureAction |
    IProjectItemTemplateCategoryValidateAction |
    IProjectItemTemplateCategoryValidateSuccessAction |
    IProjectItemTemplateCategoryValidateFailureAction |
    IProjectItemTemplateCategoryClearAction |
    IProjectItemTemplateCategoryFilterAction;
